import { render } from "./PrepareTab.vue?vue&type=template&id=f9bba080&scoped=true"
import script from "./PrepareTab.vue?vue&type=script&lang=js"
export * from "./PrepareTab.vue?vue&type=script&lang=js"

import "./PrepareTab.vue?vue&type=style&index=0&id=f9bba080&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src173764375/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bba080"]])

export default __exports__